import apiFetch from '../apiFetch'

export default function (token, fleetId) {
  return apiFetch({ endPoint: `audit/Fleets/info/download?fleetId=${fleetId}`, method: 'GET', body: null, token: token, parseBlobAndAssign: true })
}
